// extracted by mini-css-extract-plugin
module.exports = {"link":"_25d45facb5--link--xaKpq","link--phone":"_25d45facb5--link--phone--goh_E","link-disabled":"_25d45facb5--link-disabled--KZiA6"};